import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import logo from "@/assets/itfindus-horizontal-light.svg";
import { ArrowRight, Menu, X } from "lucide-react";

export default function LeadsHeader() {
  const { t } = useTranslation();
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-background/95 backdrop-blur-sm border-b border-border shadow-sm" : "bg-transparent"
      }`}
    >
      <div className="section-padding">
        <div className="h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center">
            <img src={logo} alt={t("leadsHeader.logoAlt")} className="h-20" />
          </Link>

          {/* Desktop CTA */}
          <div className="hidden md:flex items-center gap-4">
            <div className="group relative">
              <Link
                to="/registrieren"
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-accent text-accent-foreground text-sm font-medium hover:bg-accent/90 transition-colors"
              >
                 {t("leadsHeader.cta")} <ArrowRight className="w-3.5 h-3.5" />
              </Link>
              <span className="absolute top-full left-1/2 -translate-x-1/2 mt-2 px-3 py-1.5 bg-card border border-border text-xs text-muted-foreground whitespace-nowrap opacity-0 pointer-events-none group-hover:opacity-100 transition-opacity shadow-md z-50">
                {t("leadsHeader.ctaTooltip")}
              </span>
            </div>
          </div>

          {/* Mobile hamburger */}
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden p-2 text-muted-foreground hover:text-foreground transition-colors"
          >
            {mobileOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="md:hidden border-b border-border bg-background/95 backdrop-blur-sm">
          <nav className="flex flex-col gap-4 p-6">
            <Link
              to="/registrieren"
              className="inline-flex items-center justify-center gap-2 px-5 py-3 bg-accent text-accent-foreground text-sm font-medium hover:bg-accent/90 transition-colors"
              onClick={() => setMobileOpen(false)}
            >
              {t("leadsHeader.cta")} <ArrowRight className="w-3.5 h-3.5" />
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}